/** Move by local calendar days, preserving the time across daylight saving changes. */
export function addCalendarDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
